import { MessageFileSchema } from "./MessageFile";
import { ButtonSchema } from "./Button";
import { FormSchema } from "./Form";
import { MessageContentActionSchema } from "./MessageContentAction";
import { SelectionListSchema } from "./SelectionList";
import { SubmitSchema } from "./Submit";
import { SurveySchema } from "./Survey";
import { SystemMessageSchema } from "./SystemMessage";
import { VideoSchema } from "./Video";
import { z } from "zod";

export type MessageContent = z.infer<typeof MessageContentSchema>;
export const MessageContentSchema = z.object({
  disabled: z.boolean(),
  type: z.string(),
  action: MessageContentActionSchema,
  text: z.string(),
  style: z.string(),
  button: ButtonSchema,
  buttons: z.record(z.string(), z.array(z.string())), // { [key: string]: string[] };
  image: z.string(),
  video: VideoSchema,
  file: MessageFileSchema,
  form: FormSchema,
  submit: SubmitSchema,
  mention: z.array(z.string()),
  sys_msg: SystemMessageSchema,
  list: z.array(SelectionListSchema),
  option: z.any(),
  survey: SurveySchema,
  url: z.string(),
  isDisplay: z.boolean().optional(),
  selected: z.boolean().optional(),
  selectedBtnText: z.string().optional(),
  timeout: z.number().optional(), // for lamondo chat gpt widget
});
